"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var api_request_1 = require("../../api_request");
var alt_1 = require("../../alt");
var constants_1 = require("../../shared/constants");
var url_helpers_1 = require("../../shared/url_helpers");
var IMAGE_CROP = 'search_filter_preset';
var DEFAULT_PARAMS = {
    per_page: constants_1.CURATED_SET_ROW_LENGTH,
    thumb_size: IMAGE_CROP,
};
var CuratedSetRowActions = /** @class */ (function (_super) {
    tslib_1.__extends(CuratedSetRowActions, _super);
    function CuratedSetRowActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CuratedSetRowActions.prototype.buildParams = function (routeParams) {
        var params = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_PARAMS), routeParams);
        delete params.page;
        return params;
    };
    CuratedSetRowActions.prototype.setRow = function (curated_sets) {
        return curated_sets;
    };
    CuratedSetRowActions.prototype.fetchHomepage = function () {
        var _this = this;
        api_request_1.V3.get(url_helpers_1.default.curatedSetsHomepagePath(), { thumb_size: IMAGE_CROP })
            .then(function (response) { _this.setRow(response.curated_sets); })
            .fail(function () { return _this.clear(); });
        return null;
    };
    CuratedSetRowActions.prototype.fetch = function (params) {
        var _this = this;
        api_request_1.V3.get(url_helpers_1.default.curatedSetsPath(), this.buildParams(params))
            .then(function (response) { _this.setRow(response.curated_sets); })
            .fail(function () { return _this.clear(); });
        return null;
    };
    CuratedSetRowActions.prototype.clear = function () {
        this.setRow([]);
        // if you return undefined your actions won't dispatch
        return null;
    };
    return CuratedSetRowActions;
}(alt_1.AltActions));
exports.default = alt_1.default.createActions(CuratedSetRowActions);
//# sourceMappingURL=curated_set_row_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/actions/curated_set_row_actions.js
// module id = fDVn
// module chunks = 20 21